import axios from 'axios';
import { store } from '../store';

export const getSites = () => {
  const { token } = store.getState().auth;
  return new Promise((resolve, reject) => {
    axios({
      url: `${process.env.REACT_APP_MMB_API_URL}/api/config/site/list/`,
      headers: { Authorization: `Token ${token}` },
    }).then(({ data }) => {
      store.dispatch({ type: 'LOAD_TRANSLATION_SITES', payload: data });
      store.dispatch({ type: 'LOAD_FORMULARY_SITES', payload: data });
      resolve(data);
    }).catch((err) => {
      // console.log(err);
      reject(err);
    });
  });
};

export const getSiteTheme = (site) => {
  const { token } = store.getState().auth;
  store.dispatch({ type: 'SET_LOADING_FORMULARY', payload: true });
  return new Promise((resolve, reject) => {
    axios({
      url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/theme/${site}/`,
      headers: { Authorization: `Token ${token}` },
    }).then(({ data }) => {
      store.dispatch({ type: 'LOAD_SITE_THEME', payload: data });
      store.dispatch({ type: 'SET_LOADING_FORMULARY', payload: false });
      resolve(data);
    }).catch((err) => {
      // console.log(err);
      store.dispatch({ type: 'SET_LOADING_FORMULARY', payload: false });
      reject(err);
    });
  });
};

export const saveSiteTheme = (site, data) => {
  const { token } = store.getState().auth;
  store.dispatch({ type: 'SET_SAVING_FORMULARY', payload: true });
  return new Promise((resolve, reject) => {
    axios({
      method: 'put',
      url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/theme/${site}/`,
      headers: { Authorization: `Token ${token}` },
      data,
    }).then(() => {
      getSiteTheme(site);
      store.dispatch({ type: 'SET_SAVING_FORMULARY', payload: false });
      resolve();
    }).catch((err) => {
      // console.log(err);
      store.dispatch({ type: 'SET_SAVING_FORMULARY', payload: false });
      reject(err);
    });
  });
};
